import styles from "./IncidentCommunicationModal.module.css";
import PropTypes from "prop-types";
import { Modal } from "@wwg/ui";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import closeButtonImage from "./xButton.PNG";
import { action } from "@storybook/addon-actions";

/**
 *
 * Modal that opens when view is clicked on an escalated incident item. Admins can view the reason for the escalation and any related notes the Case Owner added. (There is a select displayed, but the documentation says it should just display the reason)
 *
 */

export function IncidentCommunicationModal({
  emailInfo,
  isOpen,
  onView,
  onClose,
}) {
  const [subject, setSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");

  useEffect(() => {
    if (emailInfo?.emailSubject) {
      setSubject(emailInfo.emailSubject);
    }
    if (emailInfo?.emailBody) {
      setEmailBody(emailInfo.emailBody);
    }
  }, [emailInfo]);

  return (
    <>
      <Modal
        visible={isOpen}
        children={
          <div className={styles.container}>
            <img
              src={closeButtonImage}
              className={styles.closeButton}
              onClick={onClose}
              alt=""
            />
            <div className={styles.title}>View Email</div>
            <div className={styles.hr} />

            <div className={styles.title}>Subject</div>
            <input
              type="text"
              className={styles.input}
              placeholder="No Subject"
              value={subject}
              disabled
            />
            <div className={styles.title}>Body</div>
            <textarea
              className={styles.textarea}
              placeholder="No Email Body"
              value={emailBody}
              disabled
            >
              {emailBody}
            </textarea>
          </div>
        }
      />
    </>
  );
}

IncidentCommunicationModal.propTypes = {
  isOpen: PropTypes.bool,
  onView: PropTypes.func,
  onClose: PropTypes.func,
};
